import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import SecureStorage from 'secure-web-storage';
const XE = 'ia_campaign_management_20220114';

@Injectable({
    providedIn: 'root',
})
export class StorageService {
    constructor() {}

    public secureStorage = new SecureStorage(sessionStorage, {
        hash: function hash(key: any) {
            key = CryptoJS.SHA256(key);

            return key.toString();
        },
        encrypt: function encrypt(data: any) {
            data = CryptoJS.AES.encrypt(data, XE);
            data = data.toString();
            return data;
        },
        decrypt: function decrypt(data: any) {
            data = CryptoJS.AES.decrypt(data, XE);
            data = data.toString(CryptoJS.enc.Utf8);
            return data;
        },
    });
}
